'use client';
import React from 'react';
import RenderFormFields from 'src/components/era-package/forms/RenderFormFields';
import { print3461Form, optionsMap } from 'src/views/abi/fields/print-3461-form';

const Print3461FormModal = ({ formData, setFormData }) => {

  return (
    <RenderFormFields
      fields={print3461Form}
      optionsMap={optionsMap}
      formData={formData || {}}
      setFormData={setFormData}
    />

  );
};

export default Print3461FormModal;